import { Backdrop, Box, styled, Typography } from "@mui/material";
import React, { useContext } from "react";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { RetailContext } from "../../contexts/retail/retailMain.context";

const BorderLinearProgress = styled(LinearProgress)(({}) => ({
  height: 6,
  borderRadius: "2px",
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "rgb(162, 198, 255)",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: "2px",
    backgroundColor: "#0B6BFF",
  },
}));

function LinearProgressWithLabel({ value }: { value: number }) {
  return (
    <Box>
      <Typography
        variant="body1"
        sx={{
          textAlign: "center",
          fontSize: 32,
          "@media (max-width: 600px)": {
            fontStyle: "normal",
            fontFamily: "Inter, sans-serif",
            lineHeight: "28px",
            fontSize: "20px",
            marginBottom: "16px",
          },
        }}
        mb={4}
      >{`${Math.round(value)}%`}</Typography>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ width: "100%", mr: 1 }}>
          <BorderLinearProgress variant="determinate" value={value} />
        </Box>
      </Box>
    </Box>
  );
}

export default function LoadingProgress() {
  const { progress } = useContext(RetailContext);
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={true}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box mt={4} sx={{ width: 300 }}>
          <Box sx={{ width: "100%" }}>
            <LinearProgressWithLabel value={progress} />
            <Typography
              sx={{
                textAlign: "center",
                fontSize: 18,
                "@media (max-width: 600px)": {
                  fontStyle: "normal",
                  fontFamily: "Inter, sans-serif",
                  lineHeight: "24px",
                  fontSize: "16px",
                },
              }}
              mt={2}
            >
              Đang lưu thay đổi ...
            </Typography>
          </Box>
        </Box>
      </Box>
    </Backdrop>
  );
}
